  /* EBIKO Promo Slot v2 — retry-safe, re-render-safe, sessionStorage-cached.
     Fixes for "ODA badge sometimes won't show after refresh":
       1. data-loaded marker now set AFTER successful render (was: set before fetch,
          locking out retries on any failure).
       2. sessionStorage cache (60s TTL) — survives partial section re-renders that
          replace the DOM but keep the same product.
       3. Auto-retry: failed fetches retry once after 1.5s.
       4. MutationObserver re-runs population whenever a fresh slot enters the DOM
          (handles theme partial re-renders on variant change).
       5. variant:changed event listener — re-fetches when variant changes (different
          variant may have different net price / promo eligibility). */
  (function(){
    if (window.__ebkPromoSlotInit) return; /* this whole IIFE runs only once per page */
    window.__ebkPromoSlotInit = true;

    var API='https://ebiko-order-tracker.onrender.com';
    var CACHE_TTL_MS = 60 * 1000;

    var T={
      success:{c:'#15803d',g1:'#dcfce7',g2:'#bbf7d0',ib:'#22c55e'},
      urgency:{c:'#dc2626',g1:'#fee2e2',g2:'#fecaca',ib:'#ef4444'},
      gift:   {c:'#7c3aed',g1:'#ede9fe',g2:'#ddd6fe',ib:'#8b5cf6'},
      volume: {c:'#2563eb',g1:'#dbeafe',g2:'#bfdbfe',ib:'#3b82f6'},
      shipping:{c:'#0d9488',g1:'#ccfbf1',g2:'#99f6e4',ib:'#14b8a6'},
      neutral:{c:'#4b5563',g1:'#f3f4f6',g2:'#e5e7eb',ib:'#6b7280'}
    };
    var icons={
      success:'<path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/>',
      urgency:'<circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>',
      gift:'<polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/><line x1="12" y1="22" x2="12" y2="7"/><path d="M12 7H7.5a2.5 2.5 0 010-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 000-5C13 2 12 7 12 7z"/>',
      volume:'<path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/>',
      shipping:'<rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/>',
      neutral:'<path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/>'
    };

    function escapeHtml(s){return String(s||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;')}
    function formatDateRange(startIso,endIso){
      function fmt(iso){if(!iso)return null;try{var d=new Date(iso);if(isNaN(d))return null;return d.toLocaleDateString('en-US',{month:'short',day:'numeric'})}catch(e){return null}}
      var s=fmt(startIso), e=fmt(endIso);
      if(s&&e)return s+' – '+e;
      if(e)return 'until '+e;
      if(s)return 'from '+s;
      return '';
    }
    function daysRemaining(endIso){
      if(!endIso)return null;
      try{var d=new Date(endIso),n=new Date();var diff=(d-n)/(1000*60*60*24);if(diff<0)return null;return Math.ceil(diff);}catch(e){return null}
    }

    function makePill(bg1,bg2,iconBg,iconSvg,text,textColor,tip){
      var wrap=document.createElement('span');
      wrap.style.cssText='position:relative;display:inline-block;flex-shrink:0';

      var el=document.createElement('span');
      el.style.cssText='display:inline-flex;align-items:center;gap:7px;padding:6px 14px 6px 8px;border-radius:50px;background:linear-gradient(135deg,'+bg1+','+bg2+');font-family:var(--text-font-family);cursor:'+(tip?'pointer':'default')+';transition:transform .15s ease,box-shadow .15s ease;flex-shrink:0';
      el.innerHTML='<span style="display:flex;align-items:center;justify-content:center;width:22px;height:22px;background:'+iconBg+';border-radius:50%;flex-shrink:0"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">'+iconSvg+'</svg></span><span style="font-size:13px;font-weight:700;color:'+textColor+';line-height:1;white-space:nowrap">'+text+'</span>';
      wrap.appendChild(el);

      // Hover tooltip — only render if there's meaningful detail to show.
      var hasTip = tip && (tip.subtext || tip.name || tip.endsAt || tip.startsAt);
      if(hasTip){
        var tipEl=document.createElement('div');
        tipEl.style.cssText='position:absolute;top:calc(100% + 10px);left:0;min-width:220px;max-width:320px;background:#0f172a;color:#fff;padding:13px 15px;border-radius:10px;font-size:12px;line-height:1.5;box-shadow:0 12px 30px rgba(0,0,0,.25);opacity:0;pointer-events:none;transform:translateY(-4px);transition:opacity .18s ease,transform .18s ease;z-index:9999;';
        var arrow=document.createElement('div');
        arrow.style.cssText='position:absolute;top:-5px;left:22px;width:10px;height:10px;background:#0f172a;transform:rotate(45deg);';
        tipEl.appendChild(arrow);

        var html='<div style="position:relative;">';
        if(tip.name) html+='<div style="font-weight:700;font-size:13px;margin-bottom:6px;color:#fbbf24;letter-spacing:.3px;text-transform:uppercase;">'+escapeHtml(tip.name)+'</div>';
        html+='<div style="font-weight:600;font-size:14px;color:#fff;margin-bottom:3px;">'+escapeHtml(text)+'</div>';
        if(tip.subtext) html+='<div style="color:#cbd5e1;font-size:12px;">'+escapeHtml(tip.subtext)+'</div>';
        var dates=formatDateRange(tip.startsAt,tip.endsAt);
        var daysLeft=daysRemaining(tip.endsAt);
        if(dates){
          html+='<div style="color:#94a3b8;margin-top:9px;padding-top:8px;border-top:1px solid rgba(255,255,255,.08);font-size:11px;display:flex;align-items:center;gap:5px;">'+
            '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="flex-shrink:0"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>'+
            '<span>'+escapeHtml(dates)+'</span>';
          if(daysLeft!=null&&daysLeft<=14) html+='<span style="margin-left:auto;color:#fcd34d;font-weight:600;">'+(daysLeft===0?'Ends today':daysLeft+' day'+(daysLeft===1?'':'s')+' left')+'</span>';
          html+='</div>';
        }
        html+='</div>';
        tipEl.innerHTML=html;
        wrap.appendChild(tipEl);

        var hideTimer=null;
        function show(){if(hideTimer){clearTimeout(hideTimer);hideTimer=null}tipEl.style.opacity='1';tipEl.style.transform='translateY(0)';tipEl.style.pointerEvents='auto'}
        function hide(){tipEl.style.opacity='0';tipEl.style.transform='translateY(-4px)';tipEl.style.pointerEvents='none'}
        function hideSoon(){hideTimer=setTimeout(hide,120)}

        el.onmouseenter=function(){el.style.transform='translateY(-1px)';el.style.boxShadow='0 3px 12px rgba(0,0,0,0.1)';show()};
        el.onmouseleave=function(){el.style.transform='';el.style.boxShadow='';hideSoon()};
        tipEl.onmouseenter=show;
        tipEl.onmouseleave=hide;
        // Tap-to-toggle for mobile
        el.onclick=function(ev){ev.stopPropagation();if(tipEl.style.opacity==='1')hide();else show()};
      } else {
        el.onmouseenter=function(){el.style.transform='translateY(-1px)';el.style.boxShadow='0 3px 12px rgba(0,0,0,0.1)'};
        el.onmouseleave=function(){el.style.transform='';el.style.boxShadow=''};
      }
      return wrap;
    }

    function renderInto(slot, results){
      var promoData=results[0];
      var netData=results[1];
      slot.innerHTML=''; /* idempotent — clear before render so re-runs don't duplicate */

      if(promoData&&promoData.hasPromo&&promoData.badges&&promoData.badges.length){
        var seen={};
        promoData.badges.forEach(function(b){
          if(seen[b.text])return;
          seen[b.text]=1;
          var t=T[b.style]||T.success;
          var ic=icons[b.style]||icons.success;
          slot.appendChild(makePill(t.g1,t.g2,t.ib,ic,b.text,t.c,{
            name: slot.getAttribute('data-product-id') === '7394183544907' ? 'Etch-Rite ET-50R Jumbo Refill — Q3 Special' : (b.name || ''),
            subtext: b.subtext || '',
            startsAt: b.startsAt || '',
            endsAt: b.endsAt || ''
          }));
        });
      }

      if(netData&&netData.success&&netData.promo_net_price&&netData.promo_net_price.buy_qty&&netData.promo_net_price.get_qty){
        var bq=netData.promo_net_price.buy_qty;
        var gq=netData.promo_net_price.get_qty;
        var gd=netData.promo_net_price.get_discount||1;
        var dealText='Buy '+bq+' Get '+gq+(gd>=1?' Free':' at '+(gd*100).toFixed(0)+'% Off');
        var dealShown=promoData&&promoData.badges&&promoData.badges.some(function(b){return String(b.text||'').indexOf(dealText)>=0;});
        var giftIcon='<polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/><line x1="12" y1="22" x2="12" y2="7"/><path d="M12 7H7.5a2.5 2.5 0 010-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 000-5C13 2 12 7 12 7z"/>';
        if(!dealShown)slot.appendChild(makePill('#dcfce7','#bbf7d0','#22c55e',giftIcon,dealText,'#15803d',{
          name: 'Shopify Bulk Discount',
          subtext: 'Automatic discount at checkout'
        }));
      }

      /* A badge's own "Net $X" wins: it is the printed flyer price. Shopify's route only knows product-wide deals. */
      var badgeNet=null;
      if(promoData&&promoData.badges){promoData.badges.forEach(function(b){if(!badgeNet&&b.netPricePerUnit)badgeNet=Number(b.netPricePerUnit).toFixed(2);});}
      var routeNet=netData&&netData.success&&netData.promo_net_price&&netData.promo_net_price.net_price;
      if(badgeNet||routeNet){
        var np=badgeNet||routeNet;
        var dollarIcon='<line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"/>';
        slot.appendChild(makePill('#fef3c7','#fde68a','#f59e0b',dollarIcon,'Net $'+np+'/unit','#92400e',{
          name: 'Net Price',
          subtext: 'Your effective per-unit cost when the bulk deal applies'
        }));
      }

      slot.setAttribute('data-loaded','1'); /* marker AFTER successful render only */
    }

    function fetchWithRetry(url, attempt){
      attempt = attempt || 0;
      var ctrl = (typeof AbortController !== 'undefined') ? new AbortController() : null;
      var timer = ctrl ? setTimeout(function(){ ctrl.abort(); }, 8000) : null;
      var opts = ctrl ? { signal: ctrl.signal } : {};
      return fetch(url, opts)
        .then(function(r){ if(timer) clearTimeout(timer); return r.ok ? r.json() : null; })
        .catch(function(){
          if(timer) clearTimeout(timer);
          if (attempt < 1) {
            return new Promise(function(resolve){
              setTimeout(function(){ resolve(fetchWithRetry(url, attempt + 1)); }, 1500);
            });
          }
          return null;
        });
    }

    function populateSlot(slot){
      if(!slot) return;
      var pid=slot.getAttribute('data-product-id');
      if(!pid) return;
      var vid=slot.getAttribute('data-variant-id')||'';
      /* skip if already loaded for THIS pid+vid combo */
      var loadedKey = pid + '|' + vid;
      if (slot.getAttribute('data-loaded-key') === loadedKey) return;
      slot.setAttribute('data-loaded-key', loadedKey);

      var vendor=slot.getAttribute('data-vendor')||'';
      var tags=slot.getAttribute('data-tags')||'';
      var cols=slot.getAttribute('data-collections')||'';
      var price=slot.getAttribute('data-price')||'';
      var promoUrl=API+'/api/promos/product/'+pid+'?variant_id='+vid+'&vendor='+encodeURIComponent(vendor)+'&tags='+encodeURIComponent(tags)+'&collections='+cols;
      var netUrl=API+'/api/storefront/net-price/'+pid+'?price='+encodeURIComponent(price)+'&variant_id='+vid+'&vendor='+encodeURIComponent(vendor)+'&tags='+encodeURIComponent(tags)+'&collections='+cols;

      var cacheKey = 'ebk_promo_' + pid + '_' + vid + '_' + price;
      try {
        var cached = sessionStorage.getItem(cacheKey);
        if (cached) {
          var parsed = JSON.parse(cached);
          if (parsed && (Date.now() - parsed.t) < CACHE_TTL_MS) {
            renderInto(slot, parsed.r);
            return;
          }
        }
      } catch(e){}

      Promise.all([fetchWithRetry(promoUrl), fetchWithRetry(netUrl)]).then(function(results){
        renderInto(slot, results);
        try {
          sessionStorage.setItem(cacheKey, JSON.stringify({ t: Date.now(), r: results }));
        } catch(e){}
      });
    }

    function scanAndPopulate(){
      /* Use class selector — id can be duplicated across multiple sections (quick view, etc.) */
      var slots = document.querySelectorAll('.ebk-promo-slot[data-product-id]');
      slots.forEach(populateSlot);
    }

    /* Initial run */
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scanAndPopulate);
    } else {
      scanAndPopulate();
    }

    /* Re-run on theme's variant:changed event (price/eligibility may differ per variant) */
    document.addEventListener('variant:changed', function(){
      /* clear loaded markers so populateSlot will refresh with new variant data */
      document.querySelectorAll('.ebk-promo-slot[data-loaded-key]').forEach(function(s){
        s.removeAttribute('data-loaded-key');
      });
      setTimeout(scanAndPopulate, 50);
    });

    /* Re-run when DOM mutations add new slots (handles partial section re-renders) */
    if (typeof MutationObserver !== 'undefined') {
      var observer = new MutationObserver(function(mutations){
        for (var i = 0; i < mutations.length; i++) {
          var added = mutations[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var n = added[j];
            if (n.nodeType !== 1) continue;
            if (n.classList && n.classList.contains('ebk-promo-slot')) {
              populateSlot(n);
            } else if (n.querySelector) {
              var inner = n.querySelector('.ebk-promo-slot[data-product-id]');
              if (inner) populateSlot(inner);
            }
          }
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  })();
